export default __webpack_public_path__ + "static/media/daniyal.43085ce4.jpg";